export default {
  // Common
  common: {
    loading: 'Cargando...',
    loadingData: 'Cargando datos...',
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    close: 'Cerrar',
    confirm: 'Confirmar',
    back: 'Volver',
    next: 'Siguiente',
    previous: 'Anterior',
    search: 'Buscar',
    filter: 'Filtrar',
    clearFilters: 'Limpiar filtros',
    clear: 'Limpiar',
    all: 'Todos',
    none: 'Ninguno',
    yes: 'Si',
    no: 'No',
    actions: 'Acciones',
    details: 'Detalles',
    download: 'Descargar',
    downloadPDF: 'Descargar PDF',
    viewDetails: 'Ver detalles',
    noData: 'Sin datos',
    error: 'Error',
    success: 'Exito',
    warning: 'Advertencia',
    info: 'Informacion',
    date: 'Fecha'
  },

  // DataTable common
  dataTable: {
    sortBy: 'Ordenar por',
    sortAsc: 'Ascendente',
    sortDesc: 'Descendente',
    filters: 'Filtros',
    applyFilters: 'Aplicar filtros',
    clearFilters: 'Limpiar filtros'
  },

  // Navigation
  nav: {
    home: 'Inicio',
    invoices: 'Facturas',
    issues: 'Incidencias',
    generation: 'Generacion',
    data: 'Datos',
    customers: 'Clientes',
    contracts: 'Contratos',
    consumptionPoints: 'Puntos de consumo',
    myAccount: 'Mi cuenta',
    profile: 'Perfil',
    linkAccount: 'Vincular cuenta',
    logout: 'Cerrar sesion',
    backToSite: 'Volver',
    operatorManagement: 'Gestión de operadores',
    impersonate: 'Suplantación',
    menu: 'Menú',
    openMenu: 'Abrir menú',
    closeMenu: 'Cerrar menú',
    help: 'Manual de usuario'
  },

  // Footer
  footer: {
    help: 'Manual de usuario',
    terms: 'Reglamento EPK',
    privacy: 'Política de privacidad',
    support: 'Problema con el portal',
    supportSubject: 'Portal EPK — problema técnico',
    securedBy: 'Pagos seguros con',
    autopayAlt: 'Autopay'
  },

  // Help / User manual
  help: {
    tocLabel: 'Tabla de contenidos',
    translationPending: 'Traducción en progreso — mostrando versión polaca.',
    sectionNotFound: 'Sección no encontrada.',
    backToHome: 'Volver al panel',
    backToFirstSection: 'Volver a la primera sección',
    loadFailed: 'No se pudo cargar el manual.'
  },

  // Auth
  auth: {
    login: 'Iniciar sesion',
    logout: 'Cerrar sesion',
    register: {
      subtitle: 'Regístrese para acceder a su portal de energía.',
      firstNamePlaceholder: 'Juan',
      lastNamePlaceholder: 'García',
      phonePlaceholder: '+48 000 000 000',
      phoneHint: '+48 está rellenado por defecto — puedes cambiarlo si el número no es de Polonia. Formato: +<código de país><dígitos>',
      phoneFormatError: 'El número debe empezar con „+" y un código de país (p. ej. +48 para Polonia).',
      passwordMinLength: 'Mínimo 8 caracteres',
      passwordMinLengthError: 'La contraseña debe tener al menos 8 caracteres',
      passwordMismatch: 'Las contraseñas no coinciden',
      submitButton: 'Registrarse',
      submitting: 'Creando cuenta...',
      failed: 'Error en el registro. Inténtelo de nuevo.',
      alreadyHaveAccount: '¿Ya tiene una cuenta? Inicie sesión'
    },
    email: 'Correo electronico',
    password: 'Contrasena',
    confirmPassword: 'Confirmar contrasena',
    firstName: 'Nombre',
    lastName: 'Apellido',
    phone: 'Telefono',
    forgotPassword: 'Olvidaste la contrasena?',
    noAccount: 'No tienes cuenta? Registrate aqui',
    hasAccount: 'Ya tienes cuenta? Inicia sesion',
    loggingIn: 'Iniciando sesion...',
    registering: 'Registrando...',
    loginFailed: 'Error de inicio de sesion. Intentalo de nuevo.',
    tooManyAttempts: 'Demasiados intentos de inicio de sesion. Intentalo de nuevo en {minutes} min.',
    registerSuccess: 'Registro exitoso. Revisa tu correo para verificar.',
    welcomeBack: 'Bienvenido de nuevo! Inicia sesion en tu cuenta.',
    createAccount: 'Crea tu cuenta en el Portal Electrónico del Cliente',
    passwordReset: 'Restablecer contrasena',
    passwordResetRequest: 'Solicitar restablecimiento de contrasena',
    passwordResetConfirm: 'Confirmar nueva contrasena',
    resetPassword: 'Restablecer contrasena',
    enterEmail: 'Ingresa tu correo electronico',
    enterNewPassword: 'Ingresa nueva contrasena',
    passwordResetSent: 'El enlace de restablecimiento se ha enviado a tu correo.',
    passwordResetSuccess: 'La contrasena ha sido cambiada. Ya puedes iniciar sesion.',
    invalidResetToken: 'Token de restablecimiento invalido o expirado.',
    tooManyAttempts: 'Demasiados intentos de inicio de sesion. Intentalo de nuevo en {minutes} min.',
    verifyEmail: {
      title: 'Verificación de correo electrónico',
      verifying: 'Verificando...',
      success: 'Tu correo electrónico ha sido verificado exitosamente.',
      alreadyVerified: 'Este correo ya ha sido verificado.',
      error: 'Token de verificación inválido o expirado.',
      noToken: 'No se encontró token de verificación en el enlace.',
      goToLogin: 'Ir al inicio de sesión'
    },
    resendVerification: {
      description: 'Introduce el correo electrónico para reenviar el enlace de activación.',
      submit: 'Enviar',
      success: 'El enlace de activación ha sido enviado al correo proporcionado.'
    },
    emailNotVerified: 'El correo electrónico no ha sido verificado. Revisa tu bandeja de entrada.',
    resendButton: 'Reenviar enlace de activación',
    alreadyVerified: 'El correo ya está verificado. Si olvidaste tu contraseña, usa la opción de restablecimiento.',
    resetPasswordLink: 'Restablecer contraseña'
  },

  // Dashboard
  dashboard: {
    welcome: 'Bienvenido, {name}!',
    welcomeDefault: 'Bienvenido, Usuario!',
    subtitle: 'Resumen de tu cuenta de energia',
    currentBalance: 'Saldo actual',
    activeContracts: 'Contratos activos',
    expiringContracts: '{count} vencen pronto',
    allContractsCurrent: 'Todos los contratos vigentes',
    monthlyConsumption: 'Consumo del mes actual',
    consumptionChange: '{percent}% {direction} que el mes pasado',
    consumptionMore: 'más',
    consumptionLess: 'menos',
    noConsumptionData: 'Sin datos del mes anterior',
    consumptionBreakdownTitle: 'Consumo de este mes por PPE',
    breakdownPpeCode: 'Código PPE',
    breakdownCustomer: 'Cliente',
    breakdownConsumption: 'Consumo',
    breakdownChange: '% m/m',
    openInvoices: 'Facturas pendientes',
    overdueInvoices: '{count} vencidas',
    noOverdueInvoices: 'Sin facturas vencidas',
    balanceOutsideSelfService: 'Parte de su saldo corresponde a documentos no disponibles en el portal — póngase en contacto con nosotros',
    newIssue: 'Nueva incidencia',
    linkCustomerAccount: 'Vincular cuenta de cliente',
    reportIssue: 'Reportar incidencia',
    recentInvoices: 'Facturas recientes',
    recentContracts: 'Contratos recientes',
    recentIssues: 'Incidencias activas recientes',
    activeTasks: 'Tareas activas',
    viewAll: 'Ver todas',
    noActiveIssues: 'Sin incidencias activas',
    allMattersResolved: 'Todos los asuntos han sido resueltos',
    loadFailed: 'Error al cargar datos del panel'
  },

  // Invoices
  invoices: {
    title: 'Facturas',
    subtitle: 'Consulta y gestiona tus facturas',
    invoiceNumber: 'Numero de factura',
    customer: 'Cliente',
    issueDate: 'Fecha de emision',
    amount: 'Importe',
    overpaymentTooltip: 'Importe del sobrepago',
    paymentDeadline: 'Fecha limite de pago',
    status: 'Estado',
    period: 'Periodo',
    consumption: 'Consumo',
    dateRange: 'Rango de fechas',
    searchPlaceholder: 'Numero de factura...',
    allCustomers: 'Todos los clientes',
    customerOptionNip: '{name} (NIF {nip})',
    customerOptionNumber: '{name} (n.º de cliente {number})',
    allStatuses: 'Todos',
    noInvoices: 'Sin facturas',
    loadFailed: 'Error al cargar facturas',
    downloadSuccess: 'Factura descargada correctamente',
    downloadFailed: 'Error al descargar PDF de factura',
    showingResults: 'Mostrando {first} a {last} de {total} facturas',
    statuses: {
      paid: 'Pagada',
      pending: 'Pendiente',
      unpaid: 'Sin pagar',
      overdue: 'Vencida',
      partiallyPaid: 'Parcialmente pagada',
      cancelled: 'Cancelada'
    },
    paymentMethod: {
      transfer: 'Transferencia bancaria',
      compensation: 'Compensación',
      payment: 'Pago'
    },
    lineItems: {
      title: 'Conceptos',
      description: 'Descripción',
      quantity: 'Cantidad',
      unitPrice: 'Precio unit.',
      value: 'Valor',
      empty: 'Sin conceptos'
    },
    detail: {
      loadFailed: 'No se pudieron cargar los detalles de la factura',
      title: 'Detalles de la factura',
      issuedOn: 'Emitida: {date}',
      billingPeriod: 'Periodo de facturación',
      paymentHistory: 'Historial de pagos',
      summary: 'Resumen',
      netAmount: 'Importe neto',
      vat: 'IVA ({rate}%)',
      totalDue: 'Total a pagar',
      paidAmount: 'Pagado',
      remainingAmount: 'Pendiente de pago',
      settledAmount: 'Liquidado',
      outstandingAmount: 'Pendiente de liquidación',
      taxId: 'NIF',
      contract: 'Contrato'
    }
  },

  // Contracts
  contracts: {
    title: 'Contratos',
    subtitle: 'Consulta y gestiona tus contratos de energia',
    contractNumber: 'Numero de contrato',
    customer: 'Cliente',
    dateFrom: 'Fecha de inicio',
    dateTo: 'Fecha de fin',
    status: 'Estado',
    searchPlaceholder: 'Numero de contrato...',
    allCustomers: 'Todos los clientes',
    allStatuses: 'Todos',
    noContracts: 'Sin contratos',
    loadFailed: 'Error al cargar contratos',
    daysUntilExpiration: '{days} dias hasta vencimiento',
    statuses: {
      active: 'Activo',
      expiring: 'Por vencer',
      expired: 'Vencido',
      pending: 'Pendiente',
      cancelled: 'Cancelado'
    },
    detail: {
      consumptionPoints: 'Puntos de consumo',
      address: 'Dirección',
      tariffGroup: 'Grupo tarifario',
      contractedPower: 'Potencia contratada'
    }
  },

  // Issues
  issues: {
    schedule: {
      before: 'Horario — antes de la corrección',
      after: 'Horario — después de la corrección',
      beforeDate: 'Fecha de la modificación errónea',
      afterDate: 'Fecha de la modificación correcta',
      selectPpeAndDate: 'Seleccione un PPE y una fecha para cargar el horario.',
    },
    title: 'Mis incidencias',
    subtitle: 'Historial y estado de tus incidencias',
    newIssue: 'Nueva incidencia',
    createFirst: 'Crea tu primera incidencia',
    noIssues: 'Sin incidencias',
    noIssuesDescription: 'Aun no tienes incidencias',
    searchPlaceholder: 'Buscar incidencias...',
    allStatuses: 'Todos',
    allCustomers: 'Todos los clientes',
    daysUntilDeadline: '{days} dias hasta el plazo',
    addReply: 'Añadir respuesta',
    replyPlaceholder: 'Escribe una respuesta...',
    loadFailed: 'Error al cargar incidencias',
    reopenedToast: 'Respuesta añadida. La incidencia se ha reabierto.',
    commentAddedToast: 'Comentario añadido',
    commentFailedToast: 'No se pudo añadir el comentario',
    finishedBanner: {
      title: 'La incidencia ha sido finalizada',
      deadlineHint: 'Aún puedes añadir un comentario durante {deadline}. Después la incidencia se cerrará definitivamente.',
      reopenHint: 'Añadir un comentario reabrirá la incidencia.'
    },
    canceledBanner: {
      title: 'Has cancelado esta incidencia',
      deadlineHint: 'Aún puedes añadir un comentario durante {deadline}. Después la incidencia se cerrará definitivamente.',
      reopenHint: 'Añadir un comentario reabrirá la incidencia.'
    },
    cancel: {
      button: 'Cancelar incidencia',
      dialogTitle: 'Cancelación de la incidencia',
      dialogQuestion: '¿Estás seguro de que quieres cancelar esta incidencia?',
      dialogHint: 'Después de cancelar podrás añadir comentarios durante 3 días. También puedes crear una nueva incidencia en cualquier momento.',
      dialogCancel: 'No, volver',
      dialogConfirm: 'Sí, cancelar incidencia',
      toastSuccess: 'La incidencia ha sido cancelada',
      toastError: 'No se pudo cancelar la incidencia'
    },
    statuses: {
      new: 'Nueva',
      inProgress: 'En progreso',
      reopened: 'Reabierta',
      waiting: 'Esperando cliente',
      waitingThirdParty: 'Esperando respuesta de distribución',
      completed: 'Completada',
      canceled: 'Cancelada',
      archived: 'Archivada',
      deferred: 'Aplazada'
    },
    fields: {
      document_number: 'Numero de documento',
      ppe_number: 'Numero PPE',
      new_reading_cycle: 'Nuevo ciclo de lectura',
      target_tariff: 'Tarifa objetivo',
      reported_to_osd: 'Se ha informado del cambio al OSD?',
      report_to_osd: 'Informar del cambio al OSD en nombre del Cliente?',
      effective_date_type: 'Fecha de vigencia del cambio',
      first_available_date: 'Primera fecha disponible',
      other_date: 'Otra fecha',
      current_power: 'Potencia contractual actual',
      target_power: 'Potencia contractual objetivo',
      connection_power_change: 'Cambia la potencia de conexion?',
      connection_power_warning: 'El cambio de potencia de conexion puede ser realizado por el Cliente directamente en el OSD.',
      block_connection_power_change: 'El cambio de potencia de conexion puede ser realizado por el Cliente directamente en el OSD.',
      is_new_connection: 'Es el nuevo PPE una nueva conexion?',
      osd: 'Cual es el OSD?',
      current_seller: 'Quien es el vendedor actual?',
      termination_period: 'Cual es el periodo de terminacion?',
      assignee_data: 'Datos del cesionario',
      assignment_start_date: 'Fecha de inicio de la cesion',
      contract_number: 'Numero de contrato',
      extension_period: 'Periodo de extension',
      installation_power: 'Potencia de la instalacion',
      energy_type: 'Tipo de energia',
      energy_type_full: 'Cantidad total',
      energy_type_surplus: 'Excedente',
      ppe_numbers: 'Numeros PPE',
      period_start: 'Periodo desde',
      period_end: 'Periodo hasta',
      new_contact: 'Nuevo telefono / email',
      keep_old_contact: 'Mantener el contacto anterior?',
      invoice_numbers: 'Numeros de factura',
      meter_reading: 'Lectura del contador',
      not_nots_number: 'Numero NOT/NOTS',
      summons_number: 'Numero de requerimiento',
      summons_date: 'Fecha del requerimiento',
      compensation_number: 'Numero de compensacion / declaracion',
      penalty_number: 'Numero de penalizacion contractual',
      additional_info: 'Descripcion',
      opis_zgloszenia: 'Descripción del caso',
      searchPlaceholder: 'Buscar...',
      yes: 'Sí',
      no: 'No',
      assignee_name: 'Nombre del cesionario',
      assignee_nip: 'NIF del cesionario',
      assignee_address: 'Dirección principal',
      assignee_correspondence_address: 'Dirección de correspondencia',
      assignee_contact: 'Datos de contacto',
      bank_name: 'Nombre del banco',
      bank_account: 'Número de cuenta bancaria',
      annual_surplus_volume_mwh: 'Volumen anual estimado de excedente',
      keep_previous_contact: '¿Mantener el número de teléfono/correo anterior para contacto?',
      selectAll: 'Todos',
      loadingOptions: 'Cargando opciones...',
      requiredField: 'Este campo es obligatorio',
      osdAutoFillPlaceholder: 'El OSD se establecerá al seleccionar el PPE',
      osdAutoFillLoading: 'Leyendo OSD del PPE...',
      osdAutoFillErrorSummary: 'Error de OSD',
      osdAutoFillError: 'No se pudo leer el OSD — contacte con soporte.',
      osdAutoFillPpeNotFound: 'No se encontró un PPE con este código. Verifique el valor.',
      osdAutoFillMissing: 'Ingrese un número de PPE para que el sistema complete el OSD. No se puede enviar la solicitud sin OSD.',
      osdAutoFillFailedPlaceholder: 'Seleccione OSD manualmente'
    },
    info: {
      overpayment_scan: 'Por favor adjunte la solicitud de reembolso de sobrepago como escaneo.',
      correction_note_scan: 'Por favor adjunte la nota de correccion como escaneo.',
      termination_signature: 'Por favor adjunte la terminacion: electronicamente con firma cualificada u original a la sede de la empresa — de lo contrario, la terminacion sera invalida.',
      assignment_osd_process: 'Despues de informar el cambio de propietario al OSD, comienza un proceso de verificacion (21 dias–1,5 meses). El operador establecera la fecha a partir de la cual se emitiran las facturas al nuevo destinatario.',
      new_connection_docs: 'Por favor adjunte la escritura de propiedad y los documentos requeridos por el OSD.',
      existing_connection_docs: 'Por favor adjunte las ultimas facturas de distribucion y al menos una factura de venta.',
      required_attachments: 'Adjuntos requeridos',
      property_right_document: 'Por favor, adjunte un documento que confirme los derechos de propiedad.',
      osd_reading_cycles: 'Ciclos de facturación disponibles según DSO',
      wniosek_zwrot_nadplaty: 'Por favor adjunte la solicitud de reembolso de sobrepago como escaneo.',
      wniosek_cesja: 'Después de informar el cambio de propietario al Operador del Sistema de Distribución (OSD), comienza un proceso de verificación (21 días–1,5 meses). El operador establecerá la fecha a partir de la cual se emitirán las facturas al nuevo destinatario.\n\nPor favor, adjunte un documento que confirme los derechos de propiedad.',
      wypowiedzenie_umowy: 'Por favor adjunte la terminación: electrónicamente con firma cualificada u original a la sede de la empresa — de lo contrario, la terminación será inválida.',
      nota_korygujaca: 'Por favor adjunte la nota de corrección como escaneo.',
      wniosek_zmiana_cyklu_odczytowego: 'Ciclos de facturación disponibles según DSO:\n• Energa: 1m, 2m, 6m, 12m\n• Tauron: 1m, 2m, 6m, 12m\n• Stoen: 1m, 6m, 12m\n• Enea: 1m, 2m, 6m, 12m\n• PGE: 1m, 2m, 6m',
      wniosek_dodanie_ppe_when_true: 'Por favor adjunte la escritura de propiedad y los documentos requeridos por el OSD.',
      wniosek_dodanie_ppe_when_false: 'Por favor adjunte las últimas facturas de distribución y al menos una factura de venta.',
      wniosek_dodanie_ppe_osd_enea: 'Para ENEA, adjunte: ficha de datos técnicos con condiciones de conexión, contrato de conexión.',
      wniosek_dodanie_ppe_osd_energa: 'Para ENERGA, adjunte: declaración de finalización de la conexión.',
      wniosek_dodanie_ppe_osd_pge: 'Para PGE, adjunte: confirmación de la posibilidad de prestar servicios de distribución y especificación de parámetros técnicos.',
      wniosek_dodanie_ppe_osd_tauron: 'Para TAURON, adjunte: certificado de finalización de conexión, ficha de datos técnicos, notificación de preparación de la instalación para la conexión.',
      wniosek_dodanie_ppe_osd_innogy: 'Para INNOGY, adjunte: datos técnicos de la conexión completada, preparación de la instalación, contrato de conexión.',
      wniosek_dodanie_ppe_osd_stoen: 'Para STOEN, adjunte: datos técnicos de la conexión completada, preparación de la instalación, contrato de conexión.'
    },
    errors: {
      formDataInvalidSummary: 'Error de formulario',
      formDataInvalid: 'Formato de datos no válido — actualiza la página y vuelve a intentarlo'
    }
  },

  // New Issue
  newIssue: {
    title: 'Nueva incidencia',
    subtitle: 'Reporta una incidencia al servicio al cliente',
    back: 'Volver',
    customer: 'Cliente',
    customerPlaceholder: 'Selecciona cliente',
    category: 'Categoria',
    categoryPlaceholder: 'Selecciona una categoria',
    subcategory: 'Subcategoria',
    subcategoryPlaceholder: 'Selecciona una subcategoria',
    selectCategoryFirst: 'Primero selecciona una categoria',
    issueTitle: 'Titulo de la incidencia',
    titlePlaceholder: 'Descripcion breve del problema...',
    description: 'Descripcion',
    descriptionPlaceholder: 'Descripcion detallada del problema, circunstancias, expectativas...',
    descriptionHint: 'Proporciona todos los detalles posibles para acelerar la resolucion.',
    submit: 'Enviar incidencia',
    cancel: 'Cancelar',
    submitting: 'Enviando...',
    submitSuccess: 'Incidencia creada correctamente. Redirigiendo...',
    submitFailed: 'Error al crear incidencia. Intentalo de nuevo.',
    attachments: 'Archivos adjuntos',
    addMoreFiles: 'Agregar más archivos',
    formFields: 'Datos del formulario',
    validation: {
      customerRequired: 'Selecciona un cliente',
      categoryRequired: 'Selecciona una categoría de incidencia',
      subcategoryRequired: 'Selecciona una subcategoría de incidencia',
      titleRequired: 'Ingresa titulo de incidencia',
      titleMinLength: 'El titulo debe tener al menos 5 caracteres',
      descriptionRequired: 'Ingresa descripcion de incidencia',
      descriptionMinLength: 'La descripcion debe tener al menos 20 caracteres',
      dynamicFieldRequired: 'El campo "{field}" es obligatorio',
      numericRequired: 'Por favor, introduzca un número',
      minValue: 'El valor no puede ser menor que {min}'
    },
    help: {
      title: 'Como enviar una incidencia?',
      step1: '1. Selecciona un cliente - si tienes acceso a varias cuentas, selecciona a cual se refiere la incidencia.',
      step2: '2. Por favor, seleccione la categoría y subcategoría adecuadas para identificar el problema más rápido y acelerar su resolución.',
      step3: '3. Describe en detalle - proporciona toda la informacion relevante: numeros de documento, fechas, circunstancias.',
      footer: 'Después de enviar, recibirá una confirmación y nuestro equipo se encargará del asunto en un plazo de 14 días.'
    }
  },

  // Meter Reading
  meterReading: {
    title: 'Enviar lectura del contador',
    submit: 'Enviar lectura'
  },

  // Navigation (additional)
  navigation: {
    newIssue: 'Enviar incidencia',
    meterReading: 'Enviar lectura del contador'
  },

  // Customers
  customers: {
    title: 'Clientes',
    subtitle: 'Gestiona tus cuentas de cliente vinculadas',
    customerName: 'Cliente',
    customerNumber: 'Numero de cliente',
    nipPesel: 'NIF/DNI',
    linkedAt: 'Fecha de vinculacion',
    searchPlaceholder: 'Buscar cliente...',
    searchHint: 'Nombre, numero de cliente o NIF',
    ppeSearchPlaceholder: 'Buscar punto...',
    ppeSearchHint: 'Codigo PPE, direccion o tarifa',
    noCustomers: 'Sin cuentas de cliente vinculadas'
  },

  // Consumption Points
  consumptionPoints: {
    title: 'Puntos de consumo y generacion de energia',
    subtitle: 'Gestiona tus puntos de consumo y generacion de energia',
    ppeCode: 'Codigo PPE',
    noCode: 'Sin codigo',
    customer: 'Cliente',
    category: 'Categoria',
    tariff: 'Tarifa',
    contract: 'Contrato',
    contractActive: 'Activo',
    contractInactive: 'Inactivo',
    searchPlaceholder: 'Buscar punto...',
    searchHint: 'Codigo PPE, direccion, tarifa o cliente',
    allCategories: 'Todos',
    allCustomers: 'Todos los clientes',
    noConsumptionPoints: 'Sin puntos de consumo y generacion',
    loadFailed: 'Error al cargar puntos de consumo',
    invoicesEmpty: 'No hay facturas para este punto',
    categories: {
      consumption: 'Consumo',
      generation: 'Generacion'
    }
  },

  // Generation Scheduling
  scheduling: {
    contractedPower: 'Potencia contratada',
    generationSource: 'Fuente de generacion',
    unitKw: 'kW',
    title: 'Programacion de generacion',
    subtitle: 'Gestiona los programas de generacion de energia para puntos de generacion',
    listTitle: 'Programacion de generacion',
    listSubtitle: 'Gestiona los programas de generacion de energia para puntos de generacion',
    detailTitle: 'Programa de generacion',
    selectPoint: 'Selecciona punto de generacion',
    pointPlaceholder: 'Selecciona punto...',
    selectDate: 'Selecciona fecha',
    scheduleDate: 'Fecha del programa',
    schedule: 'Programa',
    schedule24h: 'Programa de 24 horas',
    hour: 'Hora',
    valueKwh: 'Valor (kWh)',
    systemProposed: 'Sistema (kWh)',
    effectiveValue: 'Efectivo (kWh)',
    source: 'Fuente',
    sourceSystem: 'Sistema',
    sourceUser: 'Usuario',
    sourceSystemUser: 'Sistema+Usuario',
    total: 'Total',
    totalEdited: 'Total editado',
    totalSystem: 'Total sistema',
    totalEffective: 'Total efectivo',
    userHours: 'Horas de usuario',
    editedNow: 'Editado ahora',
    deadline: 'Plazo',
    deadlinePassed: 'Plazo vencido',
    deadlineInfo: 'Plazo de envio: {time}',
    deadlineNotice: 'Plazo de envio del programa: {time}',
    saveSchedule: 'Guardar',
    downloadExcel: 'Descargar',
    uploadFromFile: 'Cargar desde archivo',
    restoreSystem: 'Restaurar valores del sistema',
    noPoints: 'Sin puntos de generacion',
    loadFailed: 'Error al cargar programa',
    saveSuccess: 'Programa guardado correctamente',
    saveFailed: 'Error al guardar programa',
    deadlinePassedError: 'El plazo de envio del programa ha vencido',
    noChanges: 'Sin cambios para guardar',
    hoursModified: '{count} horas',
    // List page
    generationPoint: 'Punto de generacion',
    noPpeCode: 'Sin codigo PPE',
    customer: 'Cliente',
    allCustomers: 'Todos los clientes',
    systemTotal: 'Total sistema',
    effectiveTotal: 'Total efectivo',
    editSchedule: 'Editar/ver programa',
    refresh: 'Actualizar',
    showingPoints: 'Mostrando {first} a {last} de {totalRecords} puntos',
    // Source/status labels
    sources: {
      none: 'Sin datos',
      system: 'Sistema',
      partial: 'Sistema+Usuario',
      full: 'Usuario'
    },
    // Upload dialog
    uploadDialog: {
      title: 'Cargar programa desde archivo Excel',
      description: 'Puedes descargar una plantilla y modificarla, o descargar el programa actual, modificarlo e importarlo aqui.',
      downloadTemplate: 'descargar plantilla',
      warning: 'Si el archivo contiene fecha o codigo PPE, deben coincidir con el programa seleccionado.',
      selectFile: 'Selecciona archivo Excel',
      upload: 'Cargar',
      uploadSuccess: 'Cargados {count} valores horarios. Haz clic en "Guardar" para guardar cambios.',
      uploadFailed: 'Error al leer archivo Excel. Verifica que el archivo tenga el formato correcto.',
      noData: 'No se encontraron datos horarios en el archivo',
      dateMismatch: 'La fecha en el archivo ({fileDate}) no coincide con la fecha seleccionada ({selectedDate})',
      ppeMismatch: 'El codigo PPE en el archivo ({filePpe}) no coincide con el actual ({currentPpe})',
      invalidStatuses: 'Se omitieron estados desconocidos o no permitidos para las horas: {hours}',
      invalidStatusReasons: {
        notAllowedAfterDeadline: 'no permitido despues del plazo'
      }
    },
    // Status column
    status: 'Estado',
    statusOptions: {
      none: 'Ninguno',
      other: 'Otro',
      pseRedispatch: 'Redespacho PSE',
      installationFailure: 'Falla de instalacion',
      powerReduction: 'Reduccion de potencia',
      plannedMaintenance: 'Mantenimiento planificado',
      plannedShutdown: 'Apagado planificado'
    },
    setStatusForAll: 'Establecer estado para todas las horas',
    bulkStatusDescription: 'El estado seleccionado se aplicara a las 24 horas del programa.',
    selectStatus: 'Selecciona estado',
    apply: 'Aplicar',
    // Deadline indicator
    deadlineIndicator: {
      canEdit: 'Puedes editar el programa hasta',
      cannotEdit: 'El plazo de edicion ha vencido',
      statusOnly: 'Despues del plazo solo puedes cambiar el estado (Redespacho PSE, Falla de instalacion)'
    },
    // Other
    modified: 'Modificado',
    lastChange: 'Ultimo cambio',
    back: 'Volver',
    systemApplied: 'Los valores del sistema se han aplicado a todas las horas',
    templateDownloaded: 'Plantilla descargada',
    templateDownloadFailed: 'Error al descargar plantilla',
    excelDownloaded: 'Archivo Excel descargado',
    excelDownloadFailed: 'Error al descargar archivo Excel',
    editingUnavailable: 'La edicion del programa no esta disponible',
    uploadUnavailable: 'La carga del programa no esta disponible - plazo vencido',
    tolerance: {
      exceeded: 'El valor supera el límite de tolerancia ({max} kWh)',
      importWarning: '{count} valores superan el límite de tolerancia ({max} kWh/h)'
    }
  },

  // Account Matching
  accountMatching: {
    title: 'Vincular cuenta de cliente',
    subtitle: 'Vincula tu cuenta de cliente para acceder a facturas, contratos y puntos de consumo',
    verification: 'Verificacion de cuenta',
    modeNip: 'Verificación con NIF',
    modeNipDescription: 'Para empresas y clientes que tienen NIF',
    modePesel: 'Verificación con PESEL',
    modePeselDescription: 'Para clientes particulares sin NIF',
    nip: 'NIF',
    nipPlaceholder: '0000000000',
    nipHint: 'Numero de identificacion fiscal de 10 digitos',
    pesel: 'PESEL',
    peselPlaceholder: '00000000000',
    peselHint: 'Número PESEL polaco de 11 dígitos del contrato',
    peselFormatError: 'El número PESEL debe tener 11 dígitos y una suma de control válida.',
    identifierNone: '—',
    phone: 'Numero de telefono',
    phonePlaceholder: '+48 000 000 000',
    phoneHint: '+48 está rellenado por defecto — puedes cambiarlo si el número no es de Polonia. Formato: +<código de país><dígitos>',
    phoneFormatError: 'El número debe empezar con „+" y un código de país (p. ej. +48 para Polonia).',
    customerNumber: 'Numero de cliente',
    customerNumberPlaceholder: '123456',
    customerNumberHint: 'Numero del contrato o factura',
    submit: 'Vincular cuenta',
    submitting: 'Verificando...',
    success: 'Cuenta vinculada correctamente!',
    failed: 'Error al vincular cuenta. Verifica tus datos.',
    notFound: 'No se encontro cuenta con los datos proporcionados.',
    alreadyLinked: 'Esta cuenta ya está vinculada a tu perfil.',
    rateLimited: 'Demasiados intentos. Intentalo mas tarde.',
    attemptsRemaining: 'Intentos restantes: {count}',
    noAttemptsLeft: 'Has agotado el limite de intentos. Intentalo de nuevo en {minutes} min. Los datos introducidos deben coincidir con el contrato — comprueba también si has seleccionado el modo de verificación correcto (NIF o PESEL). Más información en el manual de usuario:',
    noAttemptsLeftUnknown: 'Ese fue tu último intento — el siguiente será bloqueado. Los datos introducidos deben coincidir con el contrato — comprueba también si has seleccionado el modo de verificación correcto (NIF o PESEL). Más información en el manual de usuario:',
    instructions: 'Para vincular tu cuenta, proporciona datos de verificacion de una factura o contrato.',
    linkedAccounts: 'Cuentas vinculadas',
    accountsCount: '{count} cuenta | {count} cuentas',
    noLinkedAccounts: 'Aun no tienes cuentas vinculadas',
    useFormAbove: 'Usa el formulario de arriba para vincular tu cuenta de cliente',
    active: 'Activo',
    linked: 'Vinculado',
    detach: 'Desvincular',
    detachConfirm: 'Estas seguro de que quieres desvincular esta cuenta?',
    detachFailed: 'Error al desvincular cuenta.'
  },

  // Profile
  profile: {
    title: 'Perfil de usuario',
    subtitle: 'Cliente del portal',
    personalInfo: 'Informacion de cuenta',
    email: 'Correo electronico',
    userId: 'ID de usuario',
    linkedCustomers: 'Clientes vinculados',
    firstName: 'Nombre',
    lastName: 'Apellido',
    phone: 'Telefono',
    changePassword: 'Cambiar contrasena',
    currentPassword: 'Contrasena actual',
    newPassword: 'Nueva contrasena',
    confirmNewPassword: 'Confirmar nueva contrasena',
    saveChanges: 'Guardar cambios',
    updateSuccess: 'Perfil actualizado correctamente',
    updateFailed: 'Error al actualizar perfil',
    passwordChangeSuccess: 'Contrasena cambiada correctamente',
    passwordChangeFailed: 'Error al cambiar contrasena',
    editComingSoon: 'Las funciones de edicion de perfil estaran disponibles pronto.',
    deleteAccount: 'Eliminar cuenta',
    deleteAccountTitle: 'Eliminación de cuenta',
    deleteAccountWarning: 'Esta operación es irreversible. Todos sus datos personales serán eliminados permanentemente y el acceso a su cuenta será bloqueado.',
    confirmDeletion: 'Confirmar eliminación',
    deleteAccountSuccess: 'La cuenta ha sido eliminada.',
    deleteAccountError: 'No se pudo eliminar la cuenta. Verifique su contraseña e intente de nuevo.',
    enterPasswordToConfirm: 'Ingrese su contraseña actual para confirmar',
    linkedAccountsWarning: 'Sus vínculos con {count} cuentas de clientes serán desactivados.',
    accountDeletedBanner: 'La cuenta ha sido eliminada y anonimizada exitosamente.',
    adminCannotDelete: 'Las cuentas de administrador no pueden ser eliminadas por uno mismo. Contacte con soporte.',
    tooManyAttempts: 'Demasiados intentos. Inténtelo de nuevo más tarde.'
  },

  // Operator Management
  operatorManagement: {
    title: 'Gestión de operadores',
    subtitle: 'Asignar y revocar acceso de operador a instalaciones de producción',
    assign: {
      title: 'Asignar operador',
      description: 'Otorgar a un usuario acceso de operador a una instalación de producción específica.',
      userEmail: 'Email del usuario',
      userEmailPlaceholder: "operador{'@'}ejemplo.com",
      customerNumber: 'Número de cliente',
      customerNumberPlaceholder: 'ej. 12345',
      ppeCode: 'Código PPE',
      ppeCodePlaceholder: 'ej. PPE-001W',
      ppeCodeHint: 'Código PPE que termina en W (instalación de producción)',
      ppeSelectCustomerFirst: 'Primero seleccione un cliente',
      submit: 'Asignar operador',
      success: 'El usuario ha sido asignado como operador.',
      failed: 'No se pudo asignar el operador.',
      errorUserNotFound: 'Solo puede añadir usuarios registrados.',
      errorInvalidRole: 'El usuario no puede ser asignado como operador.',
      fullAccessConfirmHeader: 'Confirmar asignación de Full Access',
      fullAccessConfirmMessage: 'Este usuario tiene el rol Full Access. Se le otorgará acceso completo a este cliente. ¿Desea continuar?'
    },
    operators: {
      title: 'Lista de operadores',
      filterPlaceholder: 'Buscar operador, cliente, PPE...',
      operator: 'Operador',
      customer: 'Cliente',
      ppe: 'Instalación (PPE)',
      role: 'Rol',
      roleOperator: 'Operador',
      roleFullAccess: 'Acceso Total',
      noOperators: 'No hay operadores asignados',
      loadFailed: 'No se pudo cargar la lista de operadores',
      removeTooltip: 'Revocar acceso',
      removeHeader: 'Confirmar revocación de acceso',
      removeConfirm: '¿Está seguro de que desea revocar el acceso de operador para {email} al cliente {customer}?',
      removeAccept: 'Revocar acceso',
      removeFailed: 'No se pudo revocar el acceso de operador.',
      showingResults: 'Mostrando {first} a {last} de {totalRecords} operadores'
    },
    observe: {
      title: 'Asignar observador',
      description: 'Otorgar a un usuario acceso de observador a un PPE específico. El mismo usuario no puede ser asignado al mismo PPE dos veces.',
      userEmail: 'Email del usuario',
      userEmailPlaceholder: "observador{'@'}ejemplo.com",
      customerNumber: 'Número de cliente',
      customerNumberPlaceholder: 'ej. 12345',
      ppeCode: 'Código PPE',
      ppeCodePlaceholder: 'ej. PPE-001',
      ppeCodeHint: 'Cualquier punto de consumo o producción',
      ppeSelectCustomerFirst: 'Primero seleccione un cliente',
      submit: 'Asignar observador',
      success: 'El usuario ha sido asignado como observador.',
      failed: 'No se pudo asignar el observador.'
    },
    observers: {
      title: 'Lista de observadores',
      filterPlaceholder: 'Buscar observador, cliente, PPE...',
      observer: 'Observador',
      customer: 'Cliente',
      ppe: 'PPE',
      noObservers: 'No hay observadores asignados',
      loadFailed: 'No se pudo cargar la lista de observadores',
      removeTooltip: 'Revocar acceso de observador',
      removeHeader: 'Confirmar revocación de acceso',
      removeConfirm: '¿Está seguro de que desea revocar el acceso de observador para {email} al PPE {ppe}?',
      removeAccept: 'Revocar acceso',
      removeFailed: 'No se pudo revocar el acceso de observador.',
      showingResults: 'Mostrando {first} a {last} de {totalRecords} observadores'
    }
  },

  // Impersonation
  impersonate: {
    startError: 'No se pudo iniciar la suplantación — sesión restaurada',
    banner: {
      acting_as: 'Actuando como {email}',
      stop: 'Detener suplantación'
    },
    panel: {
      title: 'Suplantación de usuario',
      search: 'Buscar usuario (email, nombre)...',
      email: 'Email',
      role: 'Rol',
      customers: 'Clientes vinculados',
      action: 'Suplantar',
      confirm_title: 'Confirmar suplantación',
      confirm_message: '¿Está seguro de que desea actuar como {email}?'
    },
    error: {
      forbidden: 'Suplantación no permitida',
      admin_target: 'No se puede suplantar a un administrador'
    }
  },

  // Deletion warning
  deletion_warning: {
    banner: {
      message: 'Su cuenta será eliminada el {date} debido a: {reason}. Inicie sesión regularmente para evitar la eliminación.'
    },
    reasons: {
      expired_contract: 'vencimiento del contrato',
      unverified_account: 'cuenta no verificada'
    }
  },

  // Errors
  errors: {
    general: 'Ha ocurrido un error',
    networkError: 'Error de conexion al servidor',
    unauthorized: 'Sesion expirada. Inicia sesion de nuevo.',
    forbidden: 'Acceso denegado a este recurso',
    notFound: 'Recurso no encontrado',
    serverError: 'Error del servidor. Intentalo mas tarde.'
  },

  // 404 Page
  notFound: {
    title: 'Pagina no encontrada',
    message: 'Lo sentimos, la pagina que buscas no existe.',
    backHome: 'Volver al inicio'
  },

  // Payment
  payment: {
    success: {
      title: 'Pago aceptado',
      message: 'Gracias por su pago.',
      sync_info: 'El estado de la factura se actualizará en unos minutos.',
    },
    processing: {
      title: 'Pago en curso',
      message: 'Hemos recibido su orden de pago. La factura se marcará como pagada cuando su banco lo confirme, normalmente en unos minutos.',
    },
    error: {
      title: 'Algo salió mal',
      message: 'No se pudo procesar el pago. Inténtelo de nuevo o contacte con soporte.',
      contact: 'Contacte con soporte: {email}',
      contact_with_phone: 'Contacte con soporte: {email}, tel. {phone}',
      invoice_already_paid: 'La factura ya ha sido pagada.',
      customer_email_missing: 'Falta el email del cliente. Contacte con soporte.',
      access_denied: 'Acceso denegado.',
      gateway_unavailable: 'Pasarela de pago no disponible. Inténtelo más tarde.',
      rate_limit_exceeded: 'Demasiados intentos. Inténtelo en unos minutos.',
      invoice_unpaid: 'La factura sigue sin pagar.',
    },
    neutral: {
      title: 'Estado del pago',
      message: 'No se puede confirmar el estado del pago. Revise sus facturas.',
    },
    invoice: 'Factura',
    back_to_invoice: 'Volver a la factura',
    view_invoices: 'Ver facturas',
    login: 'Iniciar sesión',
    loading: 'Comprobando estado del pago...',
    pay_amount: 'Pagar {amount}',
    redirecting: 'Redirigiendo a la pasarela de pago...',
    invoice_paid: 'Factura pagada',
    pay_page: {
      title: 'Pago de factura',
      invoice: 'Factura',
      amount_due: 'A pagar',
      due_date: 'Fecha de vencimiento',
      customer: 'Cliente',
      validity_info: 'Al hacer clic en "Pagar" será redirigido a la pasarela de pago. Tiene 24 horas para completar el pago.',
      already_paid: 'La factura ha sido pagada.',
      token_expired: 'El enlace ha expirado. Contacte con soporte en {email} para obtener un nuevo enlace.',
      token_expired_with_phone: 'El enlace ha expirado. Contacte con soporte en {phone} o {email} para obtener un nuevo enlace.',
      invalid_token: 'Enlace de pago no válido. Contacte con soporte en {email}.',
      invalid_token_with_phone: 'Enlace de pago no válido. Contacte con soporte en {phone} o {email}.',
      missing_token: 'Enlace de pago no válido. Contacte con soporte en {email}.',
      missing_token_with_phone: 'Enlace de pago no válido. Contacte con soporte en {phone} o {email}.',
      invoice_not_found: 'Factura no encontrada.',
      gateway_error: 'Pasarela de pago temporalmente no disponible. Inténtelo más tarde.',
      invoice_already_paid: 'La factura ya ha sido pagada.',
      rate_limit_exceeded: 'Demasiados intentos. Inténtelo en unos minutos.',
      payment_in_progress: 'El pago se está procesando. La factura se marcará como pagada cuando el banco lo confirme.',
      connection_error: 'No se puede conectar con el servidor. Compruebe su conexión a internet e inténtelo de nuevo.',
    },
  }
}
